import React, { useEffect, useState } from 'react';
import ConfettiGif from '../assets/img/confetti.gif';
import { cn } from '../utils/classUtils';

interface ConfettiProps {
  customImgClassName?: string;
  customContainerClassName?: string;
}

const Confetti: React.FC<ConfettiProps> = ({
  customImgClassName,
  customContainerClassName,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setIsVisible(false);
    }, 1000);

    return () => clearTimeout(timeoutId);
  }, []);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={cn(
        'h-screen w-screen absolute z-50 left-0 top-0 bottom-0',
        customContainerClassName,
      )}
    >
      <img
        src={ConfettiGif}
        className={cn('m-auto', customImgClassName)}
        alt='confetti'
      />
    </div>
  );
};

export default Confetti;
